import React from "react";
import type { SVGProps } from "react";

const NetworksIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9 16H5C4.44772 16 4 15.5523 4 15V5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V6M9 12H4M12 20V9H20V20H12ZM12 20H9M17 16C17 15.4477 16.5523 15 16 15C15.4477 15 15 15.4477 15 16C15 16.5523 15.4477 17 16 17C16.5523 17 17 16.5523 17 16Z"
      stroke="#383838"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NetworksIcon;

